// extracted by mini-css-extract-plugin
module.exports = {"container":"avatar_container__3poIj","image":"avatar_image__FL672","hidden":"avatar_hidden__H8tP5","fallback":"avatar_fallback__iSz7Q","avatar":"avatar_avatar__2GWyp"};